import React from 'react';
import { TextField, Box } from '@mui/material';
import { AutocompleteRenderOptionState } from '@mui/material/Autocomplete';
import { SearchableDropDownProps } from '../../helpers/types';
import { StyledAutocomplete } from './Style/SearchableDropDown.style';

export interface OptionType {
  id?: number | string;
  label: string;
  value?: string;
  disabled?: boolean;
}

type SearchableDropDownPropsWithOption = SearchableDropDownProps & {
  items: OptionType[];
  selectedValues?: OptionType | OptionType[] | null;
  multiple?: boolean;
  dataTestid?: string;
  clearIcon?: any;
  limitTags?: number;
  formatLabel?: (label: string) => string;
  getOptionColor?: (option: OptionType) => string;
};

const SearchableDropDown = ({
  items,
  size,
  placeholder,
  label,
  onChange,
  selectedValues,
  multiple,
  dataTestid,
  clearIcon,
  limitTags = -1,
  formatLabel,
  getOptionColor,
}: SearchableDropDownPropsWithOption) => {
  const getDisplayLabel = (option: OptionType) =>
    formatLabel ? formatLabel(option?.label) : option?.label;
  return (
    <StyledAutocomplete
      sx={{ width: 1 }}
      multiple={multiple}
      limitTags={limitTags}
      data-testid={dataTestid}
      options={items}
      getOptionLabel={(option) => getDisplayLabel(option)}
      disableCloseOnSelect
      onChange={onChange}
      value={selectedValues}
      isOptionEqualToValue={(option: OptionType, value) =>
        option?.label === value?.label
      }
      renderOption={(props, option: OptionType, state) => {
        const isDisabled = option?.disabled;
        return (
          <Box
            component="li"
            {...props}
            key={`${option?.id ?? option?.value}-${option?.label}`}
            sx={{
              textTransform: 'capitalize',
              pointerEvents: isDisabled ? 'none' : 'auto',
              color: isDisabled ? 'text.disabled' : 'text.primary',
            }}>
            {getOptionColor && (
              <Box
                component="span"
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: getOptionColor(option),
                  display: 'inline-block',
                  mr: 1,
                  flexShrink: 0,
                }}
              />
            )}
            {getDisplayLabel(option)}
          </Box>
        );
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={placeholder}
          size={size}
          InputLabelProps={{                                                                                                
            sx: {                                                                                                           
                                                                                                                           
            }                                                                                                               
          }}
        />
      )}
      clearIcon={clearIcon}
    />
  );
};

export default SearchableDropDown;
